<template>
  <mobile-card :showFooter="showFooter" paddingTop="0.5vh">
    <template v-slot:title>
      <div style="width: 100px;float: left;text-align: left;">开票信息</div>
      <div style="width: 150px;float: right;">
        <van-radio-group v-model="invoiceIsDelay" class="flex-checkbox-group" :icon-size="12">
          <van-radio class="flex-checkbox-item2" name="0" checked-color="#005423">马上开票</van-radio>
          <van-radio class="flex-checkbox-item2" name="1" checked-color="#005423">延迟开票</van-radio>
        </van-radio-group>
      </div>
    </template>
    <template v-slot:content>
      <div class="flex-form-info">
        <van-radio-group v-model="ticketType" class="flex-checkbox-group" :icon-size="14">
          <van-radio class="flex-checkbox-item" name="1" checked-color="#005423">个人</van-radio>
          <van-radio v-if="detail.enableUseCompanyTitle" class="flex-checkbox-item" name="2" checked-color="#005423"
            >机构</van-radio
          >
        </van-radio-group>
      </div>

      <div class="flex-form-info" v-if="showPerson || !detail.enableUseCompanyTitle">
        <div class="left" style="line-height: 33px;">名称：</div>
        <div
          class="right"
          style="width:80%;border-bottom: 1px lightgreen solid;border-top:0px;border-left:0px;border-right:0px;"
        >
          <van-field
            input-align="right"
            label-align="left"
            size="14px"
            placeholder="请输入名称"
            style="padding: 0px; margin: 0px; height: 31px; line-height: 32px; padding-right: 5px;"
            v-model="detail.userName"
          />
        </div>
      </div>
      <!--            <div class="flex-form-info" v-if="showPerson">-->
      <!--                <van-field label="税号：" input-align="right" label-align="left" size="14px" placeholder="请输入税号"-->
      <!--                           style="padding: 0px" v-model="detail.taxNumber"/>-->
      <!--            </div>-->
      <div v-else>
        <div class="flex-form-info">
          <span>名称：</span>
          <span>{{ detail.name }}</span>
        </div>
        <div class="flex-form-info">
          <span>税号：</span>
          <span>{{ detail.taxNumber }}</span>
        </div>
        <div class="flex-form-info" style="height: 14px;" v-if="!showDetail">
          <span class="link" style="display:block;font-size: 12px;" @click.prevent="showDetail = true">查看明细</span>
        </div>
        <div class="flex-form-info" v-if="showDetail">
          <span>单位地址：</span>
          <span>{{ detail.address }}</span>
        </div>
        <div class="flex-form-info" v-if="showDetail">
          <span>电话号码：</span>
          <span>{{ detail.tele }}</span>
        </div>
        <div class="flex-form-info" v-if="showDetail">
          <span>开户银行：</span>
          <span>{{ detail.depositBank }}</span>
        </div>
        <div class="flex-form-info" v-if="showDetail">
          <span>银行账户：</span>
          <span>{{ detail.bank }}</span>
        </div>
        <div class="flex-form-info" style="height: 14px;" v-if="showDetail">
          <span class="link" style="display:block;font-size: 12px;" @click.prevent="showDetail = false">收起</span>
        </div>
      </div>

      <div class="flex-form-info" style="margin-top:15px;" v-if="!showRemark">
        <div class="left link" style="font-size: 12px;" @click.prevent="showRemark = !showRemark">填写票据备注</div>
      </div>
      <div class="flex-form-info" style="margin-top:15px;" v-if="showRemark">
        <div class="left link" style="font-size: 12px;" @click.prevent="showRemark = !showRemark">收起票据备注：</div>
      </div>
      <div class="flex-form-info" style="height: auto" v-if="showRemark">
        <div style="width:100%;">
          <van-field
            input-align="left"
            label-align="right"
            size="14px"
            class="text-field"
            style="padding: 0px; margin: 0px; padding-right: 5px; text-align:right"
            v-model="remark"
            rows="2"
            autosize
            type="textarea"
            :maxlength="remarkLimit"
            show-word-limit
            placeholder="请填入票据备注"
          />
        </div>
      </div>
    </template>

    <template v-if="detail.enableUseCompanyTitle" v-slot:footer>
      <div class="flex-form-footer">
        <mobile-button color="#005423" class="btn-font" @click="search">查找</mobile-button>
        <mobile-button color="#005423" class="btn-font" @click="addNew">新增</mobile-button>
      </div>
    </template>
  </mobile-card>
</template>
<script>
import mobileCard from "components/mobile-card/index";
import MobileButton from "components/mobile-button/index";

export default {
  name: "ticketInfo",
  props: {
    detail: Object,
    chooceJG: Boolean,
  },
  components: {
    MobileButton,
    mobileCard,
    // ticketAddDialog,
  },

  computed: {
    showFooter() {
      return this.ticketType === "2";
    },
    showPerson() {
      return this.ticketType === "1" || !this.detail.enableUseCompanyTitle;
    },
  },
  watch: {
    ticketType(val) {
      this.$emit("changeTicketType", Number(val));
    },
  },
  data() {
    return {
      showTicketAddDialog: false,
      enableUseCompanyTitle: true,
      ticketType: "1",
      invoiceIsDelay: "0",
      remark: "",
      showDetail: false,
      showRemark: false,
      infoList: [
        {
          name: "姓名",
          value: "12345",
        },
        {
          name: "姓名",
          value: "12345",
        },
        {
          name: "姓名",
          value: "12345",
        },
      ],
      organ: {},
    };
  },
  methods: {
    addNew() {
      this.$emit("add-organ");
    },
    search() {
      this.$emit("search-organ");
    },
    getTicketTitleAndTaxNum() {
      let title = "";
      if (this.ticketType === "1") {
        title = this.detail.userName;
      } else if (this.ticketType === "2") {
        title = this.detail.name;
      }
      return {
        title: title,
        taxNumber: this.detail.taxNumber,
        depositBank: this.detail.depositBank,
        tele: this.detail.tele,
        bank: this.detail.bank,
        address: this.detail.address,
        invoiceIsDelay: Number(this.invoiceIsDelay),
        remark: this.remark,
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.chooceJG) {
        this.ticketType = "2";
      }
    });
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.flex-checkbox-group {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #005423;
  width: 100%;

  .flex-checkbox-item {
    font-size: 14px;
    width: 24%;
  }

  .flex-checkbox-item2 {
    font-size: 12px;
    width: 80px;
  }
}

.link {
  text-decoration: underline;
  color: #005423;
}

/deep/ .flex-form-info {
  height: 38px;
  padding-top: 0px;
}

/deep/ .van-field__label--left {
  text-align: left;
}

/deep/ .card-title-div {
  width: 100%;
}

/*.flex-form-info {*/
/*    padding: 5px;*/
/*    display: flex;*/

/*    .row-info {*/
/*        padding-top: 5px;*/
/*        padding-bottom: 5px;*/

/*        span {*/
/*            margin-right: 10px;*/
/*        }*/
/*    }*/
/*}*/
</style>
